<template>
  <div class="app-content content " >
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>
      <div class="content-body" >
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <AuthLogo/>
            <!-- Left Text-->
            <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-5 mb-4"><img class="img-fluid"
                                                                                                    :src="`${publicPath}app-assets/images/pages/otp1.png`"
                                                                                               alt="Login V2"/></div>
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-5 mb-4"><img class="img-fluid"
                                                                                                    :src="`${publicPath}app-assets/images/pages/otp2.png`"
                                                                                                    alt="Login V2"/></div>
              <div style="position: absolute;top: 70%;">
                <h3 class="text-primary">Safe & Secure!</h3>
                <h3 class="text-primary ">One payment solution for all your needs.</h3>
                <p class="text-primary mb-0">Grow your business with us</p>
                <p class="text-primary mb-0">Send and receive money with ease</p>
              </div>
            </div>

            <!-- /Left Text-->
            <!-- Login-->
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h3 class="card-title font-weight-bold mb-1"><img class="w-75" :src="`${publicPath}vaults-authlogo.png`"></h3>
                <h3 class="card-title font-weight-bold mb-1">Verify the Otp!</h3>
                <p class="card-text mb-2">Please enter the otp we sent to you email address</p>
                <form class="auth-login-form mt-2" @submit.prevent="sendCall">
                  <div class="form-group">
                    <label class="form-label">Email</label>
                    <input name="email" v-model="email"
                           disabled
                           :class=" errorBag.has('email') ? 'is-invalid' : ''"
                           class="form-control"
                           type="email"
                           placeholder="Email"
                           v-validate="'required'"
                    />
                    <small
                        v-show="errorBag.has('email')"
                        class="invalid-feedback"
                    >{{ "*" + errorBag.first("email") }}</small>
                  </div>
                  <div class="form-group">
                    <label class="form-label">OTP</label>
                    <input name="otp" v-model="otp"
                           :class=" errorBag.has('otp') ? 'is-invalid' : ''"
                           class="form-control"
                           type="otp"
                           placeholder="OTP"
                           v-validate="'required'"
                    />
                    <small
                        v-show="errorBag.has('otp')"
                        class="invalid-feedback"
                    >{{ "*" + errorBag.first("otp") }}</small>
                  </div>
                  <div class="mt-2">
                    <button
                        type="submit"
                        class="btn btn-primary mr-1 d-flex"

                        :disabled="loading"
                    >
                      <Loader :loading="loading" :size="size"></Loader>
                      Send
                    </button>
                  </div>
                </form>
                <p class="mt-3"><a @click="$router.push({name:'login'})" href="javascript:void(0)"><span>Want To Change Your Email?</span></a></p>
              </div>
            </div>
            <!-- /Login-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {

    if (typeof (this.$route.params.email) == 'undefined') {
      let email = localStorage.getItem('email');
      if (email != '' && email !== null) {
        this.email = email
      } else {
        this.$router.push({name: 'login'});
      }
    } else {
      this.email = this.$route.params.email
    }

  },
  data(){
    return{
      email:'',
      otp:'',
      loading: false,
      size: "10px",
      render:false,
    }
  },
  methods: {
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;


          let data = {
            email: this.email,
            otp: this.otp,
          }


          this.makeRequest("post", "v1/verify-otp", data).then(callResponse => {
            this.loading = false;
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                if (callResponse.response.data.data) {
                  let responseData = callResponse.response.data.data;
                }
                // this.$router.push({
                //   name: "index",
                // });
                var newUrl = window.location.href.replace('auth/verify-otp','app/');
                window.location.href = newUrl
              }
            }
          });
        }
      });
    }
  },

}
</script>

